/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Swap_Reason_DislikeInputs */

const en_us2_swap_reason_dislike = /** @type {(inputs: Swap_Reason_DislikeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Don't like it`)
};

const pt_br2_swap_reason_dislike = /** @type {(inputs: Swap_Reason_DislikeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não curti`)
};

const es_419_swap_reason_dislike = /** @type {(inputs: Swap_Reason_DislikeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No me gusta`)
};

const pt_pt2_swap_reason_dislike = /** @type {(inputs: Swap_Reason_DislikeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não gosto`)
};

const fr_fr2_swap_reason_dislike = /** @type {(inputs: Swap_Reason_DislikeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je n'aime pas`)
};

const de_de2_swap_reason_dislike = /** @type {(inputs: Swap_Reason_DislikeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mag ich nicht`)
};

const it_it2_swap_reason_dislike = /** @type {(inputs: Swap_Reason_DislikeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non mi piace`)
};

/**
* | output |
* | --- |
* | "Don't like it" |
*
* @param {Swap_Reason_DislikeInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const swap_reason_dislike = /** @type {((inputs?: Swap_Reason_DislikeInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Swap_Reason_DislikeInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_swap_reason_dislike(inputs)
	if (locale === "es-419") return es_419_swap_reason_dislike(inputs)
	if (locale === "pt-PT") return pt_pt2_swap_reason_dislike(inputs)
	if (locale === "fr-FR") return fr_fr2_swap_reason_dislike(inputs)
	if (locale === "de-DE") return de_de2_swap_reason_dislike(inputs)
	if (locale === "it-IT") return it_it2_swap_reason_dislike(inputs)
	return en_us2_swap_reason_dislike(inputs)
});
export { swap_reason_dislike as "swap.reason_dislike" }